import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import { Home as HomeIcon, Wallet, CreditCard, Receipt, Settings, LogOut, Bell, Menu, X, Search, ChevronDown, User, Send, BarChart3, Clock, Users } from 'lucide-react';
// Dashboard components
import Overview from '../components/dashboard/Overview';
import Wallets from '../components/dashboard/Wallets';
import VirtualCards from '../components/dashboard/VirtualCards';
import BillPayments from '../components/dashboard/BillPayments';
import AccountSettings from '../components/dashboard/AccountSettings';
import CustomerDashboard from '../components/dashboard/CustomerDashboard';
import PaymentProcessor from '../components/dashboard/PaymentProcessor';
import TransactionHistory from '../components/dashboard/TransactionHistory';
const Dashboard = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([{
    id: 1,
    message: 'Your virtual card has been created successfully',
    isRead: false
  }, {
    id: 2,
    message: 'Payment of $15.99 to Netflix completed',
    isRead: false
  }, {
    id: 3,
    message: 'Your wallet has been funded with $500',
    isRead: true
  }]);
  const [showNotifications, setShowNotifications] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === `/dashboard${path}`;
  };
  const handleLogout = () => {
    // In a real app, you would handle logout logic here
    navigate('/');
  };
  const unreadNotificationsCount = notifications.filter(n => !n.isRead).length;
  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({
      ...n,
      isRead: true
    })));
  };
  return <div className="h-screen flex overflow-hidden bg-gray-100" data-id="element-1111">
      {/* Sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1112">
        <div className="flex flex-col w-64" data-id="element-1113">
          <div className="flex flex-col h-0 flex-1 bg-[#115800]" data-id="element-1114">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" data-id="element-1115">
              <div className="flex items-center flex-shrink-0 px-4" data-id="element-1116">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KtfgpX5czTsCWioSSfnqq/billvast_logoBB.png" alt="BillVast Logo" className="h-10 w-auto" data-id="element-1117" />
              </div>
              <nav className="mt-5 flex-1 px-2 space-y-1" data-id="element-1118">
                <Link to="/dashboard" className={`${isActive('') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1119">
                  <HomeIcon className="mr-3 h-6 w-6" data-id="element-1120" />
                  Overview
                </Link>
                <Link to="/dashboard/customer" className={`${isActive('/customer') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1121">
                  <Users className="mr-3 h-6 w-6" data-id="element-1122" />
                  Customer Dashboard
                </Link>
                <Link to="/dashboard/wallets" className={`${isActive('/wallets') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1123">
                  <Wallet className="mr-3 h-6 w-6" data-id="element-1124" />
                  Wallets
                </Link>
                <Link to="/dashboard/virtual-cards" className={`${isActive('/virtual-cards') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1125">
                  <CreditCard className="mr-3 h-6 w-6" data-id="element-1126" />
                  Virtual Cards
                </Link>
                <Link to="/dashboard/payment-processor" className={`${isActive('/payment-processor') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1127">
                  <Send className="mr-3 h-6 w-6" data-id="element-1128" />
                  Payments
                </Link>
                <Link to="/dashboard/bill-payments" className={`${isActive('/bill-payments') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1129">
                  <Receipt className="mr-3 h-6 w-6" data-id="element-1130" />
                  Bill Payments
                </Link>
                <Link to="/dashboard/transactions" className={`${isActive('/transactions') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1131">
                  <Clock className="mr-3 h-6 w-6" data-id="element-1132" />
                  Transactions
                </Link>
                <Link to="/dashboard/settings" className={`${isActive('/settings') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1133">
                  <Settings className="mr-3 h-6 w-6" data-id="element-1134" />
                  Settings
                </Link>
              </nav>
            </div>
            <div className="flex-shrink-0 flex border-t border-[#289f77] p-4" data-id="element-1135">
              <button onClick={handleLogout} className="flex-shrink-0 w-full group block" data-id="element-1136">
                <div className="flex items-center" data-id="element-1137">
                  <div data-id="element-1138">
                    <img className="inline-block h-9 w-9 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" data-id="element-1139" />
                  </div>
                  <div className="ml-3" data-id="element-1140">
                    <p className="text-sm font-medium text-white" data-id="element-1141">John Doe</p>
                    <div className="flex items-center text-xs font-medium text-[#03e8b1] group-hover:text-white" data-id="element-1142">
                      <LogOut className="mr-1 h-4 w-4" data-id="element-1143" />
                      Sign out
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} fixed inset-0 flex z-40 md:hidden`} role="dialog" aria-modal="true" data-id="element-1144">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true" onClick={() => setIsMobileMenuOpen(false)} data-id="element-1145"></div>
        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-[#115800]" data-id="element-1146">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1147">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setIsMobileMenuOpen(false)} data-id="element-1148">
              <span className="sr-only" data-id="element-1149">Close sidebar</span>
              <X className="h-6 w-6 text-white" data-id="element-1150" />
            </button>
          </div>
          <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto" data-id="element-1151">
            <div className="flex-shrink-0 flex items-center px-4" data-id="element-1152">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KtfgpX5czTsCWioSSfnqq/billvast_logoBB.png" alt="BillVast Logo" className="h-10 w-auto" data-id="element-1153" />
            </div>
            <nav className="mt-5 px-2 space-y-1" data-id="element-1154">
              <Link to="/dashboard" className={`${isActive('') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1155">
                <HomeIcon className="mr-4 h-6 w-6" data-id="element-1156" />
                Overview
              </Link>
              <Link to="/dashboard/customer" className={`${isActive('/customer') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1157">
                <Users className="mr-4 h-6 w-6" data-id="element-1158" />
                Customer Dashboard
              </Link>
              <Link to="/dashboard/wallets" className={`${isActive('/wallets') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1159">
                <Wallet className="mr-4 h-6 w-6" data-id="element-1160" />
                Wallets
              </Link>
              <Link to="/dashboard/virtual-cards" className={`${isActive('/virtual-cards') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1161">
                <CreditCard className="mr-4 h-6 w-6" data-id="element-1162" />
                Virtual Cards
              </Link>
              <Link to="/dashboard/payment-processor" className={`${isActive('/payment-processor') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1163">
                <Send className="mr-4 h-6 w-6" data-id="element-1164" />
                Payments
              </Link>
              <Link to="/dashboard/bill-payments" className={`${isActive('/bill-payments') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1165">
                <Receipt className="mr-4 h-6 w-6" data-id="element-1166" />
                Bill Payments
              </Link>
              <Link to="/dashboard/transactions" className={`${isActive('/transactions') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1167">
                <Clock className="mr-4 h-6 w-6" data-id="element-1168" />
                Transactions
              </Link>
              <Link to="/dashboard/settings" className={`${isActive('/settings') ? 'bg-[#289f77] text-white' : 'text-[#03e8b1] hover:bg-[#289f77]'} group flex items-center px-2 py-2 text-base font-medium rounded-md`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-1169">
                <Settings className="mr-4 h-6 w-6" data-id="element-1170" />
                Settings
              </Link>
            </nav>
          </div>
          <div className="flex-shrink-0 flex border-t border-[#289f77] p-4" data-id="element-1171">
            <button onClick={handleLogout} className="flex-shrink-0 group block w-full" data-id="element-1172">
              <div className="flex items-center" data-id="element-1173">
                <div data-id="element-1174">
                  <img className="inline-block h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" data-id="element-1175" />
                </div>
                <div className="ml-3" data-id="element-1176">
                  <p className="text-base font-medium text-white" data-id="element-1177">John Doe</p>
                  <div className="flex items-center text-sm font-medium text-[#03e8b1] group-hover:text-white" data-id="element-1178">
                    <LogOut className="mr-1 h-4 w-4" data-id="element-1179" />
                    Sign out
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div className="flex-shrink-0 w-14" data-id="element-1180">
          {/* Force sidebar to shrink to fit close icon */}
        </div>
      </div>
      {/* Main content */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden" data-id="element-1181">
        <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow" data-id="element-1182">
          <button type="button" className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#289f77] md:hidden" onClick={() => setIsMobileMenuOpen(true)} data-id="element-1183">
            <span className="sr-only" data-id="element-1184">Open sidebar</span>
            <Menu className="h-6 w-6" data-id="element-1185" />
          </button>
          <div className="flex-1 px-4 flex justify-between" data-id="element-1186">
            <div className="flex-1 flex" data-id="element-1187">
              <div className="w-full flex md:ml-0" data-id="element-1188">
                <label htmlFor="search-field" className="sr-only" data-id="element-1189">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600" data-id="element-1190">
                  <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none" data-id="element-1191">
                    <Search className="h-5 w-5" data-id="element-1192" />
                  </div>
                  <input id="search-field" className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm" placeholder="Search transactions" type="search" data-id="element-1193" />
                </div>
              </div>
            </div>
            <div className="ml-4 flex items-center md:ml-6" data-id="element-1194">
              <div className="relative" data-id="element-1195">
                <button className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" onClick={() => setShowNotifications(!showNotifications)} data-id="element-1196">
                  <span className="sr-only" data-id="element-1197">View notifications</span>
                  <Bell className="h-6 w-6" data-id="element-1198" />
                  {unreadNotificationsCount > 0 && <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" data-id="element-1199"></span>}
                </button>
                {/* Notifications dropdown */}
                {showNotifications && <div className="origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" data-id="element-1200">
                    <div className="py-2" data-id="element-1201">
                      <div className="px-4 py-2 border-b border-gray-200" data-id="element-1202">
                        <div className="flex justify-between items-center" data-id="element-1203">
                          <h3 className="text-sm font-semibold text-gray-900" data-id="element-1204">
                            Notifications
                          </h3>
                          <button onClick={markAllAsRead} className="text-xs text-[#289f77] hover:text-[#115800]" data-id="element-1205">
                            Mark all as read
                          </button>
                        </div>
                      </div>
                      <div className="max-h-60 overflow-y-auto" data-id="element-1206">
                        {notifications.length > 0 ? notifications.map(notification => <div key={notification.id} className={`px-4 py-2 hover:bg-gray-50 ${notification.isRead ? '' : 'bg-[#03e8b1]/10'}`} data-id="element-1207">
                              <p className="text-sm text-gray-800" data-id="element-1208">
                                {notification.message}
                              </p>
                              <p className="text-xs text-gray-500 mt-1" data-id="element-1209">
                                Just now
                              </p>
                            </div>) : <div className="px-4 py-6 text-center" data-id="element-1210">
                            <p className="text-sm text-gray-500" data-id="element-1211">
                              No notifications
                            </p>
                          </div>}
                      </div>
                      <div className="border-t border-gray-200 px-4 py-2 text-center" data-id="element-1212">
                        <button className="text-xs text-[#289f77] hover:text-[#115800]" data-id="element-1213">
                          View all notifications
                        </button>
                      </div>
                    </div>
                  </div>}
              </div>
              {/* Profile dropdown */}
              <div className="ml-3 relative" data-id="element-1214">
                <div data-id="element-1215">
                  <button type="button" className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" id="user-menu-button" data-id="element-1216">
                    <span className="sr-only" data-id="element-1217">Open user menu</span>
                    <img className="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" data-id="element-1218" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <main className="flex-1 relative overflow-y-auto focus:outline-none" data-id="element-1219">
          <Routes data-id="element-1220">
            <Route path="/" element={<Overview data-id="element-1222" />} data-id="element-1221" />
            <Route path="/customer" element={<CustomerDashboard data-id="element-1224" />} data-id="element-1223" />
            <Route path="/wallets" element={<Wallets data-id="element-1226" />} data-id="element-1225" />
            <Route path="/virtual-cards" element={<VirtualCards data-id="element-1228" />} data-id="element-1227" />
            <Route path="/payment-processor" element={<PaymentProcessor data-id="element-1230" />} data-id="element-1229" />
            <Route path="/bill-payments" element={<BillPayments data-id="element-1232" />} data-id="element-1231" />
            <Route path="/transactions" element={<TransactionHistory data-id="element-1234" />} data-id="element-1233" />
            <Route path="/settings" element={<AccountSettings data-id="element-1236" />} data-id="element-1235" />
          </Routes>
        </main>
      </div>
    </div>;
};
export default Dashboard;